import { Permission } from '../enums';
import { SelectOption } from '../models';

export type IPermission = Omit<SelectOption<Permission>, 'value'>;
